<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add Supplier
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Add
          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider class="mb-2"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col
              cols="12"
              sm="4"
              class="pb-0 required"
              v-if="
                userCategory.user_category === 3 ||
                userCategory.user_category === 6
              "
            >
              <v-autocomplete
                outlined
                v-model="editedSupplier.client_id"
                :items="clients"
                chips
                small-chips
                item-text="name"
                item-value="id"
                label="Select Client"
                @focus="fetchClientList"
                :rules="[(v) => !!v || 'Client is required.']"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                v-model="editedSupplier.supplier_name"
                label="Supplier Name"
                class="pb-0 required"
                outlined
                :rules="[(v) => !!v || 'Supplier Name is required.']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0">
              <v-text-field
                v-model="editedSupplier.supplier_code"
                label="Supplier Code"
                class="pb-0 required"
                outlined
                :rules="[(v) => !!v || 'Supplier Code is required.']"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
              <v-text-field
                v-model="editedSupplier.address1"
                maxlength="200"
                label="Address Line1"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Address Line1 is required.',
                ]"
                class="required pb-0"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
              <v-text-field
                v-model="editedSupplier.address2"
                maxlength="200"
                label="Address Line2"
                outlined
                class="pb-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0 pt-0">
              <v-autocomplete
                label="Country"
                :items="allCountries"
                v-model="editedSupplier.country"
                item-text="name"
                item-value="code"
                :rules="[(v) => !!v || 'Country is required']"
                class="required pb-0"
                outlined
                @input="cityList(editedSupplier.country)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0 pt-0">
              <v-autocomplete
                label="City"
                :items="citiesList"
                item-text="name"
                item-value="name"
                v-model="editedSupplier.city"
                :rules="[(v) => !!v || 'City is required']"
                class="required pb-0"
                :loading="cityLoader"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4" md="4" class="pb-0 pt-0">
              <v-text-field
                v-model="editedSupplier.phone"
                label="Phone Number"
                type="number"
                :rules="[
                  (v) =>
                    v.trim().length === 0 ||
                    /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(
                      v
                    ),
                ]"
                class="pb-0"
                outlined
                autocomplete="new-password"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="pb-0 pt-0">
              <v-text-field
                v-model="editedSupplier.email"
                label="Email"
                class="pb-0"
                outlined
                type="email"
                :rules="[
                  (v) =>
                    v.trim().length === 0 ||
                    /^\S+@\S+\.\S+$/.test(v) ||
                    'Email address must be valid',
                ]"
                @keydown.space.prevent
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pl-4 mb-2 pt-0">
        <v-btn color="primary" @click="save" :loading="saveLoader">
          {{ editedIndex === -1 ? "Add" : "Update" }}
        </v-btn>
        <v-btn color="primary" class="error" @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="confirmDialog" max-width="500">
      <v-card>
        <v-card-title class="headline"> Are you sure? </v-card-title>
        <v-divider class="mb-3"></v-divider>
        <v-card-text>
          Supplier code is already exists. Please change the supplier code.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="confirmDialog = false" class="mr-2">
            Yes
          </v-btn>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" @click="changeSupplierCode" v-on="on">
                No
              </v-btn>
            </template>
            <span
              >By this action Supplier will be mapped with selected
              client.</span
            >
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userCategory"]),

    formTitle() {
      return this.editedIndex === -1 ? "Add new" : "Edit";
    },
  },
  async created() {
    await this.getCountryList();
    await this.fetchClientList();
  },
  data: () => ({
    clients: [],
    addresses: [],
    options: {},
    total: 0,
    addressesLoader: false,
    statusLoader: false,
    editedIndex: -1,
    editedSupplier: {
      client_id: "",
      supplier_code: "",
      supplier_name: "",
      company: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      phone: "",
      email: "",
    },
    saveLoader: false,
    dialog: false,
    address_id: "",
    loader: false,
    citiesList: [],
    cityLoader: false,
    confirmDialog: false,
  }),

  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "addSupplier",
      "snackBar",
      "fetchCityList",
      "getCountries",
      "fetchClient",
      "linkedSupplier",
    ]),
    close() {
      this.$router.push("mapped-supplier-list");
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.userCategory.user_category === 1) {
          delete this.editedSupplier.client_id;
        }
        if (!this.editedSupplier.address2) {
          delete this.editedSupplier.address2;
        }
        if (!this.editedSupplier.phone) {
          delete this.editedSupplier.phone;
        }
        if (!this.editedSupplier.email) {
          delete this.editedSupplier.email;
        }
        this.saveLoader = true;
        this.addSupplier(this.editedSupplier)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.saveLoader = false;

            this.$router.push("mapped-supplier-list");
          })
          .catch((err) => {
            if (err.errors[0].duplicate == "True") {
              this.confirmDialog = true;
            }
            this.saveLoader = false;
          });
        this.saveLoader = false;
      }
    },
    changeSupplierCode() {
      let payload = {
        client_id: this.editedSupplier.client_id,
        supplier_code: this.editedSupplier.supplier_code,
      };
      this.linkedSupplier(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.confirmDialog = false;
        })
        .catch(() => {
          this.confirmDialog = false;
        });
    },
    async getCountryList() {
      await this.getCountries().then((res) => {
        this.allCountries = res.data;
      });
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    cityList(value) {
      this.cityLoader = true;
      this.fetchCityList(value).then((res) => {
        this.citiesList = res.data;
        this.cityLoader = false;
      });
    },
  },
};
</script>
